import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { zoomIn } from "../components/motionUtils";
import { Navigation } from "../components/Navigation";
import { resume } from "../data/resume";

const cardVariants = {
  offscreen: {
    y: 320,
  },
  onscreen: {
    y: 10,
    transition: {
      type: "spring",
      bounce: 0.4,
      duration: 0.8,
    },
  },
};

export const Notes = () => {
  const [displayedText, setDisplayedText] = useState("");
  const text =
    "A feature-rich shelf, holding every written work of mine. In the interim, you can scroll down to read about my Dev Career in the year 2022.";
  const speed = 40;

  useEffect(() => {
    let timeoutId = null;
    let i = 0;
    const type = () => {
      if (i < text.length) {
        setDisplayedText(text.slice(0, i + 1));
        i++;
        timeoutId = setTimeout(type, speed);
      }
    };

    type();

    // Cleanup function to clear the timeout
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="flex flex-col gap-1 px-8 pb-2 md:px-16 lg:px-60 md:pb-8 bg-whiteBackground w-full h-full font-poppins">
      <div className="w-full flex flex-col-reverse items-center justify-center sticky top-0 left-0 right-0 z-50 bg-whiteBackground py-2 md:py-8">
        <Navigation />
      </div>
      <div className="flex flex-col gap-16 py-10 sm:py-40 md:py-10 bg-whiteBackground w-full">
        <div className="flex flex-row items-center justify-between w-full">
          <div className="font-thin text-xs flex flex-col space-y-3 w-2/3 sm:w-3/4">
            <motion.div
              variants={zoomIn(0, 1)}
              whileInView="show"
              initial="hidden"
              viewport={{ once: false, amount: 0.25 }}
              className="w-full"
            >
              <h1 className="font-lora text-2xl sm:text-6xl">{resume.name}</h1>
              <p className="font-semibold sm:text-xl">
                <b>{resume.role}</b>
              </p>
            </motion.div>
          </div>
          <div className="font-thin text-[0.5rem] sm:text-base w-1/3 sm:w-1/4">
            <motion.div
              variants={zoomIn(0, 2)}
              whileInView="show"
              initial="hidden"
              viewport={{ once: false, amount: 0.25 }}
              className="w-full"
            >
              <p>Contact Information:</p>
              <p className="font-semibold">{resume.phone}</p>
              <div className="flex flex-row items-center gap-1">
                <span class="relative flex h-3 w-3">
                  <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                  <span class="relative inline-flex rounded-full h-3 w-3 bg-[#ffa500]"></span>
                </span>
                <a
                  className="text-sky-500 font-semibold cursor-pointer"
                  href={`mailto: ${resume.email}`}
                >
                  E-mail me
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      {/* notes section */}
      <div className="w-full flex flex-col items-center justify-center p-4 sm:p-10 gap-10">
        <motion.div
          variants={zoomIn(0, 1)}
          whileInView="show"
          initial="hidden"
          viewport={{ once: false, amount: 0.25 }}
          className="w-full flex flex-col items-center justify-center gap-10"
        >
          <img
            src="/bio.jpg"
            alt="notes"
            className="rounded-xl object-cover w-full sm:w-auto h-auto"
          />
          <h1 className="font-lora sm:text-6xl text-2xl">CABINET</h1>
        </motion.div>
        <div className="w-full h-10">
          <p className="font-lora text-sm sm:text-xl text-center font-light">
            {displayedText}
          </p>
        </div>
      </div>
      <div className="w-full flex flex-col items-center justify-center p-2 sm:p-10 gap-10">
        {resume.notes.map((note, index) => {
          return (
            <motion.div
              initial="offscreen"
              whileInView="onscreen"
              variants={cardVariants}
              viewport={{ once: false, amount: 0.1 }}
              key={index}
              className="flex flex-col w-full items-center gap-5 justify-center"
            >
              <hr className="text-[#999] w-full mb-3" />
              <div className="w-full flex flex-row items-center gap-3">
                <div className="w-[20%] sm:w-[10%] aspect-square rounded-full">
                  <img
                    src={note.image_url}
                    alt="dev career"
                    className="w-full h-full object-cover rounded-full"
                  />
                </div>
                <h1 className="text-lg sm:text-3xl font-lora font-semibold">
                  {note.note_title}
                </h1>
              </div>
              <div className="w-full">
                <div className="w-full flex flex-row justify-start">
                  <span className="text-3xl text-black">
                    <i>❝</i>
                  </span>
                </div>
                {note.rich_text}
                <div className="w-full flex flex-row justify-end">
                  <span className="text-3xl text-black">
                    <i>❞</i>
                  </span>
                </div>
              </div>
              {note.hashnode_url.length > 2 && (
                <a
                  href={note.hashnode_url}
                  target={"_blank"}
                  rel="noreferrer"
                  className="py-3 px-6 bg-[#d6d6d6] hover:bg-[#a7a7a7] text-sm sm:text-base rounded-lg flex flex-row items-center gap-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    width="24"
                  >
                    <path d="M7 17q-2.075 0-3.537-1.463Q2 14.075 2 12t1.463-3.538Q4.925 7 7 7h3q.425 0 .713.287Q11 7.575 11 8t-.287.712Q10.425 9 10 9H7q-1.25 0-2.125.875T4 12q0 1.25.875 2.125T7 15h3q.425 0 .713.287.287.288.287.713t-.287.712Q10.425 17 10 17Zm2-4q-.425 0-.712-.288Q8 12.425 8 12t.288-.713Q8.575 11 9 11h6q.425 0 .713.287.287.288.287.713t-.287.712Q15.425 13 15 13Zm5 4q-.425 0-.712-.288Q13 16.425 13 16t.288-.713Q13.575 15 14 15h3q1.25 0 2.125-.875T20 12q0-1.25-.875-2.125T17 9h-3q-.425 0-.712-.288Q13 8.425 13 8t.288-.713Q13.575 7 14 7h3q2.075 0 3.538 1.462Q22 9.925 22 12q0 2.075-1.462 3.537Q19.075 17 17 17Z" />
                  </svg>
                  Continue Reading
                </a>
              )}
              <div className="flex flex-row text-sm sm:text-xl items-center gap-10">
                <p className="font-light">{`📖 ${note.minutes} min read`}</p>
              </div>
            </motion.div>
          );
        })}
      </div>
      <div
        className="h-14 w-14 rounded-[50%] bg-white shadow-lg border-0 text-darkBlack font-extrabold text-xl flex flex-row items-center justify-center animate-[bounce_1.5s_infinite_100ms] cursor-pointer"
        onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })}
      >
        ↑
      </div>
    </div>
  );
};
